export default () => {
  const headerSearch = document.querySelector('.header__search');
  const searchBar = document.querySelector('.header__searchbar');
  const headerMobileSearch = document.querySelector('.header__mobile__search');

  const isClickedOutsideSearchBar = (target) => {
    return !searchBar.contains(target) && !headerSearch.contains(target) && !headerMobileSearch.contains(target);
  };

  if (headerSearch) {
    headerSearch.addEventListener('click', () => {
      searchBar.classList.toggle('active');
    });
  }

  if (headerMobileSearch) {
    headerMobileSearch.addEventListener('click', () => {
      searchBar.classList.toggle('active');
    });
  }

  document.addEventListener('click', (event) => {
    if (isClickedOutsideSearchBar(event.target)) {
      searchBar.classList.remove('active');
    }
  });
}
